<template>
	<tabbed-page-layout class="workforce" title="Arbejdsstyrke" :pages="pages">
		<slot name="tools" slot="tools" />
	</tabbed-page-layout>
</template>

<script>
    export default {
		props: ['pages']
    }
</script>

<style lang="scss">

</style>